import React from "react";
import { Link } from "react-router-dom";
import { Parallax } from "react-parallax";
import { Slide } from "react-awesome-reveal";
import { Grid, Container, Box, Icon } from '@mui/material';

const Services = ({data, parseContent, limitTextToWords}) => {
  return (
    <Parallax
      bgImage={`${process.env.REACT_APP_PUBLIC_URL}/img/parallax.jpg`}
      strength={300}
    >
    <div id="Services" className="text-center">
      <Container sx={{p:2}}  className="container">
        <div className="section-title">
        <h2>{data ? data.title : "...loading"}</h2>
        </div>
        <Grid  container className="row" spacing={{md:2, lg:4, xs :2}} sx={{mb:3}}>
            {data
              ? data.cards?.map((d, i) => (
                <Grid key={`${d.title}-${i}`} md={4} item >
                  <Slide direction="up" fraction={0}>
                    <Box sx={{borderRadius : 6, p:{md:2, xs:1}, backgroundColor:"rgb(20, 33, 43,.6)", transition:"all 1s ease-out", "&:hover":{ backgroundColor:"rgba(92, 169, 251,.3)"}}}>
                    {/* {d.icon ? <Box className="icon-container"><Icon>{d.icon}</Icon> </Box>: <img style={{width:"100%", height:"100%", objectFit:"cover", verticalAlign:"top"}} src={d.img} alt=""/>} */}
                    <img style={{width:"100%", height:"100%", objectFit:"cover", verticalAlign:"top"}} src={`${process.env.REACT_APP_PUBLIC_URL}/img/services/${d.img}`} alt=""/>
                    <div className="service-desc">
                      <h3>{d.title}</h3>
                      <Box style={{ textAlign:"justify"}}>{parseContent(limitTextToWords(d.text))}</Box>
                    </div>
                    <Link  to={d.link ? d.link.slug :""}>Details <Icon fontSize="lg">trending_flat</Icon></Link>
                    </Box>
                  </Slide>
                </Grid>
              ))
            : "loading"}
        </Grid>
      </Container>
    </div>
    </Parallax>
  );
};

export default Services